const data = {
  users: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      }, {
        prop: 'username',
        label: '账号',
        width: '100'
      }, {
        prop: 'roleName',
        label: '角色',
        width: '100'
      }, {
        prop: 'name',
        label: '姓名',
        width: '100'
      }, {
        prop: 'phone',
        label: '联系电话',
        width: '100'
      }, {
        prop: 'company',
        label: '工作单位',
        width: '120'
      }, {
        prop: 'bikeType',
        label: '单车类型',
        width: '80'
      }, {
        prop: 'areaId',
        label: '区域',
        width: '120'
      }, {
        prop: 'unavailableTime',
        label: '使用时效',
        width: '120'
      }, {
        fixed: 'right',
        label: '操作',
        width: '100'
      }
    ]
  },
  roles: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      }, {
        prop: 'name',
        label: '角色'
      }, {
        prop: 'description',
        label: '描述'
      }, {
        prop: 'isAudit',
        label: '是否需要审核'
      }, {
        fixed: 'right',
        label: '操作'
      }
    ]
  },
  audit: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      }, {
        prop: 'username',
        label: '账号',
        width: '100'
      }, {
        prop: 'roleName',
        label: '角色',
        width: '100'
      }, {
        prop: 'name',
        label: '姓名',
        width: '100'
      }, {
        prop: 'phone',
        label: '联系电话',
        width: '100'
      }, {
        prop: 'company',
        label: '工作单位',
        width: '120'
      }, {
        prop: 'bikeType',
        label: '单车类型',
        width: '80'
      }, {
        prop: 'unavailableTime',
        label: '使用时效',
        width: '150'
      }, {
        prop: 'status',
        label: '审核状态',
        width: '120'
      }, {
        fixed: 'right',
        label: '操作',
        width: '100'
      }
    ]
  }
}

export default data
